import { FolderKanban } from "lucide-react"

import { lazyPage } from "../lazy-page"
import { defineDashboardModule } from "../types"

export const projects = defineDashboardModule({
  id: "projects",
  nav: [
    {
      group: "Publishing",
      title: "Projects",
      to: "/projects",
      icon: FolderKanban,
    },
  ],
  routes: [
    {
      path: "/projects",
      component: lazyPage(
        () => import("./routes/project-list"),
        "ProjectListPage"
      ),
    },
    {
      path: "/projects/new",
      component: lazyPage(
        () => import("./routes/project-editor"),
        "ProjectEditorPage"
      ),
    },
    {
      path: "/projects/:id",
      component: lazyPage(
        () => import("./routes/project-editor"),
        "ProjectEditorPage"
      ),
    },
  ],
})
